// material-ui
import { Divider, Box, Card, Typography, Stack, IconButton, useMediaQuery, Modal, useTheme, Drawer } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

// third-party imports
import { useIntl } from 'react-intl';

// project imports
import { appDrawerWidth } from 'store/constant';

// types

import { modalStyle } from './UserForm';
import AuthResetPassword from 'views/pages/authentication/auth-forms/AuthResetPassword';

export default function ChangePassword({ show, handleClose }: { show: boolean; handleClose: () => void }) {
    // hooks
    const intl = useIntl();
    const theme = useTheme();
    const onlyMediumScreen = useMediaQuery(theme.breakpoints.down('xl'));

    const content = () => (
        <>
            <Stack mb={2} direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h3">
                    {intl.formatMessage({
                        id: 'change_password'
                    })}
                </Typography>
                <IconButton onClick={handleClose} sx={{ color: 'divider' }}>
                    <CloseOutlinedIcon />
                </IconButton>
            </Stack>
            <Divider sx={{ mb: 3 }} />

            <Box>
                <AuthResetPassword handleClose={handleClose} />
            </Box>
        </>
    );

    if (onlyMediumScreen) {
        return (
            <Modal
                open={show}
                onClose={handleClose}
                aria-labelledby="modal-edit-category"
                aria-describedby="modal-render-form-edit-category"
            >
                <Box sx={modalStyle}> {content()}</Box>
            </Modal>
        );
    }

    return (
        <Drawer
            open={show}
            sx={{
                ml: show ? 3 : 0,
                height: '100vh',
                flexShrink: 0,
                overflowX: 'hidden',
                width: appDrawerWidth,
                '& .MuiDrawer-paper': {
                    height: 'auto',
                    width: appDrawerWidth,
                    border: 'none'
                }
            }}
            anchor="right"
            ModalProps={{ keepMounted: true }}
            onClose={handleClose}
        >
            <Card
                elevation={2}
                sx={{
                    p: 3,
                    position: 'sticky',
                    bottom: '100%',
                    background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                    border: '1px solid',
                    borderColor: theme.palette.mode === 'dark' ? 'transparent' : theme.palette.grey[100],
                    '&:hover': {
                        border: `1px solid${theme.palette.primary.main}`
                    }
                }}
            >
                {content()}
            </Card>
        </Drawer>
    );
}
